import { Button, Dialog, DialogContent, Icons } from '@commenda/kakashi';
import { useState } from 'react';

interface DeleteBulkProductsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  totalSelected: number;
}

const DeleteBulkProductsModal = ({
  isOpen,
  onClose,
  onDelete,
  totalSelected,
}: DeleteBulkProductsModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    await onDelete();
    setIsDeleting(false);
  };

  return (
    <Dialog open={isOpen}>
      <DialogContent
        className="min-w-[600px] p-0"
        hideCloseIcon
        preventCloseOnOutsideClick
      >
        <div className="p-6 flex flex-col gap-4">
          <div className="flex items-center justify-center size-12 bg-bg-error rounded-lg">
            <Icons.Trash01 className="size-5 text-text-error" />
          </div>

          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-1">
              <h3 className="text-text-primary txt-large-bold">
                Delete {totalSelected} {totalSelected === 1 ? 'product' : 'products'}?
              </h3>
              <p className="txt-small-regular text-text-tertiary">
                The selected {totalSelected === 1 ? 'product' : 'products'} will be deleted permanently from your records. Your existing transactions will not be affected.
              </p>
            </div>

            <div className="flex gap-3 items-center justify-end">
              <Button 
                variant="secondary" 
                onClick={onClose} 
                size="sm"
                disabled={isDeleting}
              >
                Cancel
              </Button>
              <Button
                variant="destructive-primary"
                onClick={handleDelete}
                size="sm"
                disabled={isDeleting}
              >
                Delete {totalSelected === 1 ? 'product' : 'products'}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteBulkProductsModal;